import { yearState } from '@/utils';
import api from './api';
const path = 'school-contact';
export default {
	/**
	 * GET
	 */
	get(id) {
		return api.get(`${path}/get/${id}`);
	},
	getQuestion(schoolId) {
		return api.get(`/question/get-list?filters[school]=${schoolId}&filters[parent][is]=null&filters[status]=1&sorts[position]=asc&include[]=sub_questions_basic`);
	},
	getOne(id) {
		const year = yearState();
		return api.get(
			`${path}/get-one/${id}?include[]=school_basic&include[]=other_contacts_basic&include[]=ranking_data_${year - 1}&include[]=school_ratings_${year - 1}&include[]=survey_${year}`
		);
	},
	getOneContact(id) {
		return api.get(`${path}/get-one/${id}?include[]=school_basic&include[]=other_contacts_basic`);
	},
	getPayment(surveyId) {
		return api.get(`/payment/${surveyId}/survey`);
	},
	getPaymentSuccess(key, hash, session_id) {
		return api.get(`/payment/success?key=${key}&hash=${hash}&session_id=${session_id}`);
	},

	/**
	 * POST
	 */
	add(body) {
		return api.post(`${path}/add`, body);
	},
	addOne(body) {
		return api.post(`${path}/create-one`, body);
	},
	auth(token) {
		return api.post(`${path}/auth/${token}`, {});
	},
	authNoToken(body) {
		return api.post(`${path}/auth`, body);
	},
	surveyAnswer(body, surveyId, topicId) {
		return api.post(`survey/${surveyId}/answer/${topicId}`, body, { headers: { 'Content-Type': 'multipart/form-data' } });
	},
	updateInfo(body, id) {
		return api.post(`${path}/${id}/update-school-info`, body, { headers: { 'Content-Type': 'multipart/form-data' } });
	},
	saveMultiple(body) {
		return api.post(`${path}/save-multiple`, body);
	},
	resetPassword(body) {
		return api.post(`${path}/forgot-password`, body);
	},

	/**
	 * PUT , PATCH
	 */
	update(body) {
		return api.patch(`${path}/update`, body);
	},
	updateOne(body, id) {
		return api.patch(`${path}/update-one/${id}`, body);
	},
	surveyUpdate(body, surveyId) {
		return api.patch(`survey/update-one/${surveyId}`, body);
	},

	/**
	 * DELETE
	 */
	delete(id) {
		return api.delete(`${path}/delete/${id}`);
	},
	deleteOne(id) {
		return api.delete(`${path}/delete-one/${id}`);
	},
};
